import { render, staticRenderFns } from "./BoxDetailsForm.vue?vue&type=template&id=dc085824&"
import script from "./BoxDetailsForm.vue?vue&type=script&lang=js&"
export * from "./BoxDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports